const state = {
  breakpoint: 'xs'
}

const breakpoint = state => {
  const breakpoints = ['xs', 'sm', 'md', 'lg']

  const breakpointsMap = {
    xs: true,
    sm: breakpoints.indexOf(state.breakpoint) >= 1,
    md: breakpoints.indexOf(state.breakpoint) >= 2,
    lg: breakpoints.indexOf(state.breakpoint) >= 3
  }

  if (breakpointsMap.lg) {
    return 'desktop'
  } else if (breakpointsMap.sm) {
    return 'tablet'
  } else {
    return 'mobile'
  }
}

const getters = {
  isMobile: state => breakpoint(state) === 'mobile',
  isTablet: state => breakpoint(state) === 'tablet',
  isDesktop: state => breakpoint(state) === 'desktop'
}

const actions = {
  updateBreakpoint({ commit }, breakpoint) {
    commit('setBreakpoint', breakpoint)
  }
}

const mutations = {
  setBreakpoint(state, breakpoint) {
    state.breakpoint = breakpoint
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
